import { InitialStateProps } from './types';

export const initialState: InitialStateProps = {
  score: {},
  sortingDebt: {
    status: 'PARTIAL',
    partnerSystems: [],
    result: [],
  },
  myDebt: {},
  simulatedDebts: {},
};
